import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faWind, faAward, faScrewdriverWrench, faCalendarDays, faHouseChimneyUser, faSquareCheck } from '@fortawesome/free-solid-svg-icons';


import './Maintenance.scss';

import fan from './../assets/images/air2.png';

const Maintenance = () => {
  return (
    <>
      <div className='maint__container'>
        <h3 className='title__maint'>
          Maintenance Service
        </h3>
        <div className='maint__top'>
          <div className='maint__top__item'>
            <h4 className='maint__title'>
              Air conditioner service
            </h4>
            <ul className='maint__list'>
              <li className='maint__list__item'>Engineer's visit to the site</li>
              <li className='maint__list__item'>Cleaning of filters and drainage system</li>
              <li className='maint__list__item'>Cleaning the evaporator and condenser</li>
              <li className='maint__list__item'>Checking the pressure in the air conditioning system</li>
              <li className='maint__list__item'>Fan and compressor function check</li>
            </ul>
          </div>
          <div className='maint__top__item'>
            <img className='picture__of' src={fan} alt='fan'></img>
          </div>
          <div className='maint__top__item'>
            <h4 className='maint__title'>
              Air conditioner refilling
            </h4>
            <ul className='maint__list'>
              <li className='maint__list__item'>Engineer's visit to the site</li>
              <li className='maint__list__item'>Checking the pressure in the air conditioning system</li>
              <li className='maint__list__item'>Checking for refrigerant leaks</li>
              <li className='maint__list__item'>Refrigerant charge</li>
              <li className='maint__list__item'>Fan and compressor function check</li>
            </ul>
          </div>
        </div>
        <div className='blue__section'>
          <p className='maint__context'>
            An air conditioner is an indispensable device both on hot summer days and in the cold season. It creates a comfortable atmosphere in the room, provides fresh air and maintains the necessary temperature. However, as well as any complex equipment, an air conditioner needs regular service.
          </p>
          <p className='maint__context'>
            "SM Cold" company offers services on service maintenance of air conditioners, which will help you to avoid additional expenses for repair and replacement of equipment.          </p>
        </div>
        <div className='maint__why'>
          <h4 className='title__maint__why'>
            Why is air conditioner service necessary?
          </h4>
          <div className='wrapper__maint__item'>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faBolt} className="ic" />
              <p className='wr__desc__maint__top'>
              Reduced energy costs
              </p>
              <p className='wr__desc__maint__bottom'>
              Clean filters, evaporator, condenser and drainage system will help your air conditioner run more efficiently and use less energy to achieve the desired indoor temperature.              </p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faWind} className="ic" />
              <p className='wr__desc__maint__top'>
              Improving indoor air quality
              </p>
              <p className='wr__desc__maint__bottom'>
              During operation, the air conditioner collects dust, dirt and other contaminants. These can cause various respiratory diseases. Clean filters remove dust, dirt, pollen and other allergens from the air, which improves indoor air quality and promotes the health of residents.               </p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faAward} className="ic" />
              <p className='wr__desc__maint__top'>
              Retention of manufacturer's warranty
              </p>
              <p className='wr__desc__maint__bottom'>
              Most manufacturers require regular air conditioner maintenance to maintain the product warranty.              </p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faScrewdriverWrench} className="ic" />
              <p className='wr__desc__maint__top'>
              Breakage prevention
              </p>
              <p className='wr__desc__maint__bottom'>
              Service allows you to find hidden problems in the air conditioner's operation before they lead to serious breakdowns. This reduces repair costs and extends the life of the unit.              </p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faCalendarDays} className="ic" />
              <p className='wr__desc__maint__top'>
              Life increasing of the air conditioner
              </p>
              <p className='wr__desc__maint__bottom'>
              Regular air conditioner maintenance allows your air conditioner's parts to operate at peak performance and reduces the likelihood of breakdowns, which increases its lifespan.              </p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faHouseChimneyUser} className="ic" />
              <p className='wr__desc__maint__top'>
              Increasing indoor comfort
              </p>
              <p className='wr__desc__maint__bottom'>
              Running the air conditioner without noise and vibration at maximum capacity ensures comfortable temperature and convenience for the occupants in the room.              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='maint__do'>
        <div className='maint__do__wrap'>
          <h4 className='title__maint__do'>
          What does air conditioner service consist of?
          </h4>
          <div className='wrapper__maint__item'>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faSquareCheck} className="ic" />
              <p className='wr__desc__maint__top'>
              Cleaning of filters <br></br> and drainage system
              </p>
              <p className='wr__desc__maint__bottom'>
              Filters are treated with an antibacterial solution, and the internal unit is washed with a special disinfectant. This crucial maintenance step prevents respiratory issues, improves efficiency, and reduces power consumption.</p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faSquareCheck} className="ic" />
              <p className='wr__desc__maint__top'>
              Cleaning the evaporator <br></br> and condenser
              </p>
              <p className='wr__desc__maint__bottom'>
              This is to remove dust, dirt and other contaminants from the surfaces to improve the efficiency of the air conditioner.</p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faSquareCheck} className="ic" />
              <p className='wr__desc__maint__top'>
              Checking the air conditioning <br></br> system pressure
              </p>
              <p className='wr__desc__maint__bottom'>
              In this step, the refrigerant pressure in the air conditioning system is measured to ensure that it meets the recommended values.</p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faSquareCheck} className="ic" />
              <p className='wr__desc__maint__top'>
              Checking for refrigerant leaks <br></br> and charging
              </p>
              <p className='wr__desc__maint__bottom'>
              If the refrigerant level in the system is insufficient, it may be due to leaks that need to be detected and repaired. If a refrigerant leak was detected in the previous steps, Freon must be charged into the air conditioning system to the required pressure.</p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faSquareCheck} className="ic" />
              <p className='wr__desc__maint__top'>
              Fan and compressor <br></br> function check
              </p>
              <p className='wr__desc__maint__bottom'>
              This step checks that these elements are working correctly and are free from wear and tear.</p>
            </div>
            <div className='wr__item'>
              <FontAwesomeIcon icon={faSquareCheck} className="ic" />
              <p className='wr__desc__maint__top'>
              Checking the operation <br></br> of the controls
              </p>
              <p className='wr__desc__maint__bottom'>
              The correct operation of the remote control and the transmission of commands between it and all elements of the air-conditioning system control is checked.</p>
            </div>
          </div>
        </div>
        </div>
    </>
  );
};

export default Maintenance;